// This component is scoped out of CSS Editing for now, will be added in the future
const semanticClassNames = {
  root: 'mobile-menu__icon',
} as const;

export default semanticClassNames;
